<template>
  <v-col cols="3" class="d-flex justify-begin mb-2">
      <v-btn class="mx-2 gris_medio" @click="exportToCSV">
                   {{$t('general.exportar')}}<span class="material-symbols-outlined">arrow_outward</span>
                </v-btn>
                <v-btn  class="mx-2 gris_medio" @click="importFromCSV">
                 <span class="material-symbols-outlined">arrow_insert</span>  {{$t('general.importar')}}
                  <input
                    type="file"
                    accept=".csv"
                    ref="fileInput"
                    style="display: none;"
                    @change="handleUpload"
                  />
                </v-btn>
              
              </v-col>
    <div><br>
      <div class="scroll-container">
      <table>
        <!-- <caption class="table-header">Cogeneración</caption> -->
        <thead >
          <tr>
            <th class="encabezado columna_sticky "  >{{ labels.nombre }}  </th>
            <th class="encabezado"> 
               <v-tooltip location="right"> 
                  <template v-slot:activator="{ props }">
                    {{ labels_recortado.potencia_maxima }}
                    <v-icon v-bind="props">   mdi-help-circle-outline</v-icon>
                  </template>
                  <span>{{ labels.potencia_maxima }}</span>
                </v-tooltip>
            </th> 
            <th class="encabezado">{{ labels_recortado.potencia_minima }} 
              <v-tooltip location="right"> 
                  <template v-slot:activator="{ props }">
                    <v-icon v-bind="props">mdi-help-circle-outline</v-icon>
                  </template>
                  <span>{{ labels.potencia_minima }}</span>
                </v-tooltip>
            </th>
            <th class="encabezado">{{ labels_recortado.potencia_exportacion }} 
              <v-tooltip location="right"> 
                  <template v-slot:activator="{ props }">
                    <v-icon v-bind="props">mdi-help-circle-outline</v-icon>
                  </template>
                  <span>{{ labels.potencia_exportacion }}</span>
                </v-tooltip>
            </th>
            <th class="encabezado">{{ labels_recortado.rendimiento_vapor_gas }} 
              <v-tooltip location="right"> 
                  <template v-slot:activator="{ props }">
                    <v-icon v-bind="props">mdi-help-circle-outline</v-icon>
                  </template>
                  <span> {{ labels.rendimiento_vapor_gas }}</span>
                </v-tooltip>
            </th>
            <th class="encabezado">{{ labels_recortado.rendimiento_electricidad_gas }}
               <v-tooltip location="right"> 
                  <template v-slot:activator="{ props }">
                    <v-icon v-bind="props">mdi-help-circle-outline</v-icon>
                  </template>
                  <span> {{ labels.rendimiento_electricidad_gas }}</span>
                </v-tooltip>
            </th>
            <th class="encabezado">{{ labels_recortado.porcentaje_agua_caliente }}
               <v-tooltip location="right"> 
                  <template v-slot:activator="{ props }">
                    <v-icon v-bind="props">mdi-help-circle-outline</v-icon>
                  </template>
                  <span> {{ labels.porcentaje_agua_caliente }}</span>
                </v-tooltip>
            </th>
            <th class="encabezado">{{ labels_recortado.rendimiento_agua_fria_agua_caliente }}
               <v-tooltip location="right"> 
                  <template v-slot:activator="{ props }">
                    <v-icon v-bind="props">mdi-help-circle-outline</v-icon>
                  </template>
                  <span> {{ labels.rendimiento_agua_fria_agua_caliente }}</span>
                </v-tooltip>
            </th>
            <th class="encabezado">{{ labels_recortado.coeficiente_emisiones_CO2 }}
               <v-tooltip location="right"> 
                  <template v-slot:activator="{ props }">
                    <v-icon v-bind="props">mdi-help-circle-outline</v-icon>
                  </template>
                  <span> {{ labels.coeficiente_emisiones_CO2 }}</span>
                </v-tooltip>
            </th>
            <th class="encabezado">{{ labels_recortado.tiempo_arranque }}
               
                  
               
            </th>
            <th class="encabezado">{{ labels_recortado.tiempo_parada }}
               
            </th>
            <th class="encabezado">{{ labels_recortado.estado_inicial }}
               <v-tooltip location="right"> 
                  <template v-slot:activator="{ props }">
                    <v-icon v-bind="props">mdi-help-circle-outline</v-icon>
                  </template>
                  <span> {{ labels.estado_inicial }}</span>
                </v-tooltip>
            </th>
            <th class="encabezado">{{ labels_recortado.fee }}
               <v-tooltip location="right"> 
                  <template v-slot:activator="{ props }">
                    <v-icon v-bind="props">mdi-help-circle-outline</v-icon>
                  </template>
                  <span> {{ labels.fee }}</span>
                </v-tooltip>
            </th>
            <th class="encabezado">{{ labels_recortado.tiempo_minimo_acoplamiento }}
               <v-tooltip location="right"> 
                  <template v-slot:activator="{ props }">
                    <v-icon v-bind="props">mdi-help-circle-outline</v-icon>
                  </template>
                  <span> {{ labels.tiempo_minimo_acoplamiento }}</span>
                </v-tooltip>
            </th>
            <th class="encabezado">{{ labels_recortado.tiempo_minimo_parada }}
               <v-tooltip location="right"> 
                  <template v-slot:activator="{ props }">
                    <v-icon v-bind="props">mdi-help-circle-outline</v-icon>
                  </template>
                  <span> {{ labels.tiempo_minimo_parada }}</span>
                </v-tooltip>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(motor, index) in motores" :key="index" class="tabla-hover" >
            <td class="primera_columna columna_sticky" >{{ motor.nombre }}</td>
            <td >
              <input
                type="number"
                step="0.01"
                v-model.number= motor.potencia_maxima
                @input="emitChanges"
                />
            </td>
            <td>
              <input
                type="number"
                step="0.01"
                v-model.number=motor.potencia_minima
                @input="emitChanges"
              />
            </td>
            <td class="columna_ancha">
              <input
                type="number"
                step="0.01"
                v-model.number=motor.potencia_exportacion
                @input="emitChanges"
              />
            </td>
            <td>
              <input
                type="number"
                step="0.01"
                v-model.number=motor.rendimiento_vapor_gas
                @input="emitChanges"
              />
            </td>
            <td>
              <input
                type="number"
                step="0.01"
                v-model.number=motor.rendimiento_electricidad_gas
                @input="emitChanges"
              />
            </td>
            <td>
              <input
                type="number"
                step="0.01"
                v-model.number=motor.porcentaje_agua_caliente
                @input="emitChanges"
              />
            </td>
            <td>
              <input
                type="number"
                step="0.01"
                v-model.number="motor.rendimiento_agua_fria_agua_caliente"
                @input="emitChanges"
              />
            </td>
            <td>
              <input
                type="number"
                step="0.01"
                v-model.number=motor.coeficiente_emisiones_CO2
                @input="emitChanges"
              />
            </td>
            <td>
              <input
                type="number"
                v-model.number="motor.tiempo_arranque"
                @input="emitChanges"
              />
            </td>
            <td>
              <input
                type="number"
                v-model.number="motor.tiempo_parada"
                @input="emitChanges"
              />
            </td>
            <td>
              <select v-model="motor.estado" @change="emitChanges" :class="{ 'motor_apagado': motor.estado === 'Parado', 'motor_encendido': motor.estado === 'Encendido' }">
                <option value="Parado" class="motor_apagado" >Parado</option>
                <option value="Encendido" class="motor_encendido">Encendido</option>
              </select>
            </td>
            <td>
              <input
                type="number"
                step="0.01"
                v-model.number="motor.fee"
                @input="emitChanges"
              />
            </td>
            <td>
              <input
                type="number"
                v-model.number="motor.tiempo_minimo_acoplamiento"
                @input="emitChanges"
              />
            </td>
            <td>
              <input
                type="number"
                v-model.number="motor.tiempo_minimo_parada"
                @input="emitChanges"
              />
            </td>
          </tr>
        </tbody>
      </table>
     </div>
    </div>
  </template>
  
  <script>
  import Swal from "sweetalert2";
  const HEADERS_OFICIALES = [
  "Nombre",
  "Potencia máxima",
  "Potencia mínima",
  "Potencia exportación",
  "Rendimiento vapor/gas",
  "Rendimiento electricidad/gas",
  "Porcentaje agua caliente",
  "Rendimiento agua fría/agua caliente",
  "Coeficiente emisiones CO2",
  "Tiempo arranque",
  "Tiempo parada",
  "Estado",
  "Fee",
  "Tiempo mínimo acoplamiento",
  "Tiempo mínimo parada"
];
  export default {
    props: {
      modelValue: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        motores: Array.isArray(this.modelValue) ? [...this.modelValue] : [],
        labels: {
          nombre: this.$t("planta.planta_motores_cogeneracion"),
          potencia_maxima: this.$t("planta.motores_cogeneracion.potencia_maxima"),
          potencia_minima: this.$t("planta.motores_cogeneracion.potencia_minima"),
          potencia_exportacion: this.$t("planta.motores_cogeneracion.potencia_exportacion"),
          rendimiento_vapor_gas: this.$t("planta.motores_cogeneracion.rendimiento_vapor_gas"),
          rendimiento_electricidad_gas: this.$t("planta.motores_cogeneracion.rendimiento_electricidad_gas"),
          porcentaje_agua_caliente: this.$t("planta.motores_cogeneracion.porcentaje_agua_caliente"),
          rendimiento_agua_fria_agua_caliente: this.$t("planta.motores_cogeneracion.rendimiento_agua_fria_agua_caliente"),
          coeficiente_emisiones_CO2: this.$t("planta.motores_cogeneracion.coeficiente_emisiones_CO2"),
          tiempo_arranque: this.$t("planta.motores_cogeneracion.tiempo_arranque"),
          tiempo_parada: this.$t("planta.motores_cogeneracion.tiempo_parada"),
          estado_inicial: this.$t("planta.motores_cogeneracion.estado_inicial"),
          fee: this.$t("planta.motores_cogeneracion.fee"),
          tiempo_minimo_acoplamiento: this.$t("planta.motores_cogeneracion.tiempo_minimo_acoplamiento"),
          tiempo_minimo_parada: this.$t("planta.motores_cogeneracion.tiempo_minimo_parada"),
        },

        labels_recortado: {
         
          potencia_maxima: this.$t("planta.motores_cogeneracion_corto.potencia_maxima"),
          potencia_minima: this.$t("planta.motores_cogeneracion_corto.potencia_minima"),
          potencia_exportacion: this.$t("planta.motores_cogeneracion_corto.potencia_exportacion"),
          rendimiento_vapor_gas: this.$t("planta.motores_cogeneracion_corto.rendimiento_vapor_gas"),
          rendimiento_electricidad_gas: this.$t("planta.motores_cogeneracion_corto.rendimiento_electricidad_gas"),
          porcentaje_agua_caliente: this.$t("planta.motores_cogeneracion_corto.porcentaje_agua_caliente"),
          rendimiento_agua_fria_agua_caliente: this.$t("planta.motores_cogeneracion_corto.rendimiento_agua_fria_agua_caliente"),
          coeficiente_emisiones_CO2: this.$t("planta.motores_cogeneracion_corto.coeficiente_emisiones_CO2"),
          tiempo_arranque: this.$t("planta.motores_cogeneracion_corto.tiempo_arranque"),
          tiempo_parada: this.$t("planta.motores_cogeneracion_corto.tiempo_parada"),
          estado_inicial: this.$t("planta.motores_cogeneracion_corto.estado_inicial"),
          fee: this.$t("planta.motores_cogeneracion_corto.fee"),
          tiempo_minimo_acoplamiento: this.$t("planta.motores_cogeneracion_corto.tiempo_minimo_acoplamiento"),
          tiempo_minimo_parada: this.$t("planta.motores_cogeneracion_corto.tiempo_minimo_parada"),
        },
      };
    },
    watch: {
      modelValue: {
        handler(newValue) {
          this.motores = Array.isArray(newValue) ? [...newValue] : [];
        },
        deep: true,
      },
    },
    methods: {
      toCsvDecimalComma(v, fixed = null) {
        if (v === null || v === undefined || v === '') return '';
        const n = Number(v);
        if (Number.isNaN(n)) return '';
        const s = fixed != null ? n.toFixed(fixed) : String(n);
        return s.replace('.', ',');
      },
      /*
       // Función para formatear números a dos decimales para la vista
      formatDecimal(value) {
        return value ? parseFloat(value).toFixed(2) : "0.00";
      },

      // Función para actualizar valores con redondeo 
      updateMotor(index, key, value) {
        const newValue = parseFloat(parseFloat(value).toFixed(2)); // Convierte a número y redondea

        this.motores = Object.assign([], this.motores, { [index]: { ...this.motores[index], [key]: newValue } });

        // Emitir cambios al padre
        this.$emit("update:modelValue", [...this.motores]);
      },
      */
      emitChanges() {
        this.$emit("update:modelValue", this.motores);
      },
     exportToCSV() {
  try {
    const headers = HEADERS_OFICIALES;

    const rows = this.motores.map((m) => [
      m.nombre ?? '',
      this.toCsvDecimalComma(m.potencia_maxima),
      this.toCsvDecimalComma(m.potencia_minima),
      this.toCsvDecimalComma(m.potencia_exportacion),
      this.toCsvDecimalComma(m.rendimiento_vapor_gas),
      this.toCsvDecimalComma(m.rendimiento_electricidad_gas),
      this.toCsvDecimalComma(m.porcentaje_agua_caliente),
      this.toCsvDecimalComma(m.rendimiento_agua_fria_agua_caliente),
      this.toCsvDecimalComma(m.coeficiente_emisiones_CO2),
      (m.tiempo_arranque ?? '').toString(),
      (m.tiempo_parada ?? '').toString(),
      (m.estado === 'Encendido' || m.estado === 'Parado') ? m.estado : '',
      this.toCsvDecimalComma(m.fee),
      (m.tiempo_minimo_acoplamiento ?? '').toString(),
      (m.tiempo_minimo_parada ?? '').toString(),
    ].join(';'));

    const csvContent = [headers.join(';'), ...rows].join('\n');
    const blob = new Blob(["\uFEFF" + csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "motores_cogeneracion.csv";
    a.click();
    URL.revokeObjectURL(url);

    Swal.fire({ icon: 'success', title: 'Exportación correcta', timer: 1600, showConfirmButton: false });
  } catch (e) {
    Swal.fire({ icon: 'error', title: 'Error al exportar', text: e?.message || 'Revisa los datos.' });
  }
},

      importFromCSV() {
        this.$refs.fileInput.click();
      },

      handleUpload(event) {
  const file = event.target.files[0];
  if (!file) return;

  if (!/\.csv$/i.test(file.name)) {
    Swal.fire({ icon: 'error', title: 'Formato no válido', text: 'Solo se admiten archivos .csv.' });
    event.target.value = '';
    return;
  }

  const reader = new FileReader();
  reader.onload = (e) => {
    try {
      const content = e.target.result;
      const lines = content.replace(/\r\n/g, '\n').split('\n').filter(Boolean);
      if (lines.length < 2) throw new Error('El CSV está vacío.');

      // ====== Validación de CABECERAS ======
      let headers = lines[0]
  .split(';')
  .map((h, i) => (i === 0 ? String(h).replace(/^\uFEFF/, '') : String(h)).trim());

// 1) faltantes / extras
const faltantes = HEADERS_OFICIALES.filter(h => !headers.includes(h));
const extrasRaw = headers.filter(h => !HEADERS_OFICIALES.includes(h));

// limpiar valores vacíos/espacios 
const extras = extrasRaw.map(x => String(x).trim()).filter(Boolean);

// 2) desordenadas solo si no hay faltantes ni extras visibles
let desordenadas = [];
if (faltantes.length === 0 && extras.length === 0) {
  HEADERS_OFICIALES.forEach((h, i) => {
    if (headers[i] !== h) desordenadas.push(`${h} (posición esperada ${i + 1})`);
  });
}

// 3) renderizar solo secciones con elementos
const seccion = (titulo, arr) => {
  const items = (arr || []).map(x => String(x).trim()).filter(Boolean);
  return items.length
    ? `<h4 style="margin:6px 0 2px 0;">${titulo}</h4>
       <ul style="margin:0 0 8px 18px; padding:0;">${items.map(x => `<li>${x}</li>`).join('')}</ul>`
    : '';
};

if (faltantes.length || extras.length || desordenadas.length) {
  const html =
    `<div style="text-align:left;">
       <p>El CSV no respeta la <b>plantilla oficial</b> (encabezados y orden).</p>
       ${seccion('❌ Faltan', faltantes)}
       ${seccion('⚠️ Sobran', extras)}
       ${seccion('🔄 Desordenadas', desordenadas)}
       <p style="margin-top:6px;"><small>
         Consejo: exporta la plantilla oficial y copia tus datos respetando los encabezados y su orden.
       </small></p>
     </div>`;
  Swal.fire({ icon: 'error', title: 'Encabezados incorrectos', html, width: 800 });
  event.target.value = '';
  return;
}
      // ====== Fin validación de CABECERAS ======

      // Índices 
      const IDX = {
        nombre: 0,
        potMax: 1,              // Potencia máxima
        potMin: 2,              // Potencia mínima
        potExport: 3,           // Potencia exportación
        rendVapGas: 4,          // Rendimiento vapor/gas
        rendElecGas: 5,         // Rendimiento electricidad/gas
        pctAguaCal: 6,          // Porcentaje agua caliente (0..100)
        rendAguaFriaCal: 7,     // Rendimiento agua fría/agua caliente
        coefCO2: 8,             // Coeficiente emisiones CO2
        tArranque: 9,           // Tiempo arranque (int ≥ 0)
        tParada: 10,            // Tiempo parada (int ≥ 0)
        estado: 11,             // Estado (Encendido/Parado)
        fee: 12,                // Fee
        tMinAcopl: 13,          // Tiempo mínimo acoplamiento (int ≥ 0)
        tMinParada: 14          // Tiempo mínimo parada (int ≥ 0)
      };

      // Helpers
      const raw = (arr, i) => String(arr[i] ?? '').trim();
      const parseNumberStrict = (value) => {
        const s = String(value ?? '').trim();
        if (s === '') return { ok: false, num: NaN }; // vacío => inválido
        const n = this.parseNumber(s);                // respeta coma/punto
        return { ok: Number.isFinite(n), num: n };
      };
      const parseIntStrictGE0 = (value) => {
        const s = String(value ?? '').trim();
        if (s === '') return { ok: false, num: NaN };
        const n = parseInt(s, 10);
        return { ok: Number.isInteger(n) && n >= 0, num: n };
      };

      // Trackers de errores
      const faltasPorCol = {};
      headers.forEach(h => faltasPorCol[h] = []);
      const negativosPorCol = {};
      [IDX.potMax, IDX.potMin, IDX.potExport, IDX.rendVapGas, IDX.rendElecGas, IDX.pctAguaCal, IDX.rendAguaFriaCal, IDX.coefCO2, IDX.fee]
        .forEach(i => negativosPorCol[headers[i]] = []);
      const inconsistencias = [];

      const nuevos = [];

      for (let i = 1; i < lines.length; i++) {
        const cols = lines[i].split(';');
        if (cols.every(c => c.trim() === '')) continue; // fila vacía completa
        if (cols.length !== HEADERS_OFICIALES.length) {
          throw new Error(`Fila ${i + 1}: número de columnas inválido (${cols.length}).`);
        }
        const row = i + 1;

        // Lectura 
        const nombre = raw(cols, IDX.nombre);
        const estado = raw(cols, IDX.estado);

        // Requeridos vacíos 
        headers.forEach((h, idx) => { if (raw(cols, idx) === '') faltasPorCol[h].push(row); });

        // Numéricos decimales ≥ 0
        const { ok: okPotMax, num: potMax } = parseNumberStrict(cols[IDX.potMax]);
        const { ok: okPotMin, num: potMin } = parseNumberStrict(cols[IDX.potMin]);
        const { ok: okPotExp, num: potExport } = parseNumberStrict(cols[IDX.potExport]);
        const { ok: okRvg,     num: rendVapGas } = parseNumberStrict(cols[IDX.rendVapGas]);
        const { ok: okReg,     num: rendElecGas } = parseNumberStrict(cols[IDX.rendElecGas]);
        const { ok: okPct,     num: pctAguaCal } = parseNumberStrict(cols[IDX.pctAguaCal]);
        const { ok: okRafc,    num: rendAguaFriaCal } = parseNumberStrict(cols[IDX.rendAguaFriaCal]);
        const { ok: okCO2,     num: coefCO2 } = parseNumberStrict(cols[IDX.coefCO2]);
        const { ok: okFee,     num: fee } = parseNumberStrict(cols[IDX.fee]);

        // Enteros ≥ 0
        const { ok: okTA, num: tArranque } = parseIntStrictGE0(cols[IDX.tArranque]);
        const { ok: okTP, num: tParada }   = parseIntStrictGE0(cols[IDX.tParada]);
        const { ok: okTMA, num: tMinAcopl } = parseIntStrictGE0(cols[IDX.tMinAcopl]);
        const { ok: okTMP, num: tMinParada }= parseIntStrictGE0(cols[IDX.tMinParada]);

        // Marcar no numéricos como faltas 
        const markIfBad = (ok, idx) => { if (raw(cols, idx) !== '' && !ok) faltasPorCol[headers[idx]].push(row); };
        markIfBad(okPotMax, IDX.potMax);
        markIfBad(okPotMin, IDX.potMin);
        markIfBad(okPotExp, IDX.potExport);
        markIfBad(okRvg, IDX.rendVapGas);
        markIfBad(okReg, IDX.rendElecGas);
        markIfBad(okPct, IDX.pctAguaCal);
        markIfBad(okRafc, IDX.rendAguaFriaCal);
        markIfBad(okCO2, IDX.coefCO2);
        markIfBad(okFee, IDX.fee);
        markIfBad(okTA, IDX.tArranque);
        markIfBad(okTP, IDX.tParada);
        markIfBad(okTMA, IDX.tMinAcopl);
        markIfBad(okTMP, IDX.tMinParada);

        // Negativos NO permitidos 
        const negCheck = (ok, num, idx) => { if (ok && num < 0) negativosPorCol[headers[idx]].push(row); };
        negCheck(okPotMax, potMax, IDX.potMax);
        negCheck(okPotMin, potMin, IDX.potMin);
        negCheck(okPotExp, potExport, IDX.potExport);
        negCheck(okRvg, rendVapGas, IDX.rendVapGas);
        negCheck(okReg, rendElecGas, IDX.rendElecGas);
        negCheck(okRafc, rendAguaFriaCal, IDX.rendAguaFriaCal);
        negCheck(okCO2, coefCO2, IDX.coefCO2);
        negCheck(okFee, fee, IDX.fee);

        if (okPct) {
          if (pctAguaCal < 0 || pctAguaCal > 100) {
            inconsistencias.push(`Fila ${row}: '${headers[IDX.pctAguaCal]}' debe estar entre 0 y 100.`);
          }
        }

        // Coherencias
        if (okPotMax && okPotMin && potMin > potMax) {
          inconsistencias.push(`Fila ${row}: 'Potencia mínima' no puede superar a 'Potencia máxima'.`);
        }
        if (estado && estado !== 'Encendido' && estado !== 'Parado') {
          inconsistencias.push(`Fila ${row}: 'Estado' debe ser 'Encendido' o 'Parado'.`);
        }

        // Construcción provisional 
        nuevos.push({
          nombre: nombre || null,
          potencia_maxima: okPotMax ? potMax : null,
          potencia_minima: okPotMin ? potMin : null,
          potencia_exportacion: okPotExp ? potExport : null,
          rendimiento_vapor_gas: okRvg ? rendVapGas : null,
          rendimiento_electricidad_gas: okReg ? rendElecGas : null,
          porcentaje_agua_caliente: okPct ? pctAguaCal : null,
          rendimiento_agua_fria_agua_caliente: okRafc ? rendAguaFriaCal : null,
          coeficiente_emisiones_CO2: okCO2 ? coefCO2 : null,
          tiempo_arranque: okTA ? tArranque : null,
          tiempo_parada: okTP ? tParada : null,
          estado: estado || null,
          fee: okFee ? fee : null,
          tiempo_minimo_acoplamiento: okTMA ? tMinAcopl : null,
          tiempo_minimo_parada: okTMP ? tMinParada : null,
        });
      }

      // Consolidar errores
      const colsFaltas = Object.entries(faltasPorCol).filter(([, arr]) => arr.length);
      const colsNeg = Object.entries(negativosPorCol).filter(([, arr]) => arr.length);

      if (colsFaltas.length || colsNeg.length || inconsistencias.length) {
        const bloques = [];
        if (colsFaltas.length) {
          const htmlF = colsFaltas.map(([col, arr]) =>
            `• <b>${col}</b>: líneas <b>${arr.slice(0, 12).join(', ')}${arr.length > 12 ? '…' : ''}</b>`
          ).join('<br>');
          bloques.push(`<h4 style="margin:8px 0 4px 0;">Faltan datos obligatorios / no numéricos</h4>${htmlF}`);
        }
        if (colsNeg.length) {
          const htmlN = colsNeg.map(([col, arr]) =>
            `• <b>${col}</b>: líneas <b>${arr.slice(0, 12).join(', ')}${arr.length > 12 ? '…' : ''}</b>`
          ).join('<br>');
          bloques.push(`<h4 style="margin:8px 0 4px 0;">Valores negativos no permitidos</h4>${htmlN}`);
        }
        if (inconsistencias.length) {
          bloques.push(
            `<h4 style="margin:8px 0 4px 0;">Inconsistencias</h4>
             <ul style="margin:0 0 8px 18px; padding:0;">${inconsistencias.map(m => `<li>${m}</li>`).join('')}</ul>`
          );
        }

        Swal.fire({
          icon: 'error',
          title: 'Errores en datos',
          html: `<div style="text-align:left; max-height:50vh; overflow:auto;">${bloques.join('<br>')}</div>`,
          width: 820
        });
        event.target.value = '';
        return; // bloquear importación
      }

      // Sin errores → aplicar
      this.motores = nuevos;
      this.emitChanges();
      Swal.fire({ icon: 'success', title: 'Importación correcta', text: `${nuevos.length} registros importados.` });

    } catch (err) {
      Swal.fire({ icon: 'error', title: 'Error al importar', text: err?.message ?? 'Archivo no válido.' });
    } finally {
      event.target.value = ''; // limpia el input
    }
  };

  reader.readAsText(file, 'utf-8');
},

      parseNumber(value) {
      if (!value) return 0;

      
      value = value.trim();

      
      if (value.includes(',') && !value.includes('.')) {
        value = value.replace(/\./g, '');        
        value = value.replace(',', '.');          
      }

      
      else if (value.includes(',') && value.includes('.')) {
        
        if (value.lastIndexOf(',') > value.lastIndexOf('.')) {
          value = value.replace(/\./g, '');       
          value = value.replace(',', '.');      
        }
        
        else {
          value = value.replace(/,/g, '');        
        }
      }

      

      return parseFloat(value);
    },

    },
  };
  </script>
  
  <style scoped>

 
  /* Contenedor con scroll horizontal y vertical */
  .scroll-container {
  width: 100%;
  height: 100%;
  max-height: calc(100vh - 200px); /* Ajusta según el header y otros elementos */
  overflow-x: auto;
  overflow-y: auto;
   border-radius: 10px;
  display: flex;
  flex-direction: column;
}

  thead {
    position: sticky;
    top: 0;
    background-color: white;
    z-index: 10;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    text-align: center;
  }
  .table-header {
    font-size: 1.5em;
    font-weight: bold;
    text-align: center;
    margin-bottom: 8px;
    color: white;
    background-color: #006699;
    
  }
  


  .columna_ancha{
    min-width: 100px;
  }
  </style>
  